
// import router from '../router'
const axios = require('axios')

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // if (error.response.status === 401) {
  //   router.push('/')
  // }
  return Promise.reject(error)
})
